var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg029Cake1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    height: 512,
    viewBox: "0 0 100 100",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.498 58.466h70.15c.813 0 1.473.659 1.473 1.473v8.275c0 .813-.659 1.473-1.473 1.473h-70.15c-.813 0-1.472-.659-1.472-1.472v-8.277c-.001-.813.658-1.472 1.472-1.472z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.498 75.32h70.15c.813 0 1.473.659 1.473 1.473v8.275c0 .813-.659 1.473-1.473 1.473h-70.15c-.813 0-1.472-.659-1.472-1.472v-8.277c-.001-.812.658-1.472 1.472-1.472z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m94.975 47.189v37.88c0 .813-.659 1.473-1.473 1.473h-8.242c-.813 0-1.473-.659-1.473-1.473v-30.763c0-.813-.659-1.473-1.473-1.473h-75.816c-.813 0-1.472-.659-1.472-1.472v-3.298c0-.539.294-1.034.767-1.292l60.741-33.132c.225-.123.471-.185.728-.18 3.413.061 27.713 1.625 27.713 33.73z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg029Cake1);
export default __webpack_public_path__ + "static/media/029-cake-1.f70f87a062342658d40b54655ebbc669.svg";
export { ForwardRef as ReactComponent };